<!--基础组件：顶部tip提示
    @dengli
    @date 2018年11月2日
    props
        - status {String}  - 用于提示颜色图标等状态切换(只有三个状态：succeed，failed，normal)
        - content {String}  - 提示的文字内容
    调用示例:
        <popup status="succeed" content="复制成功"/>
-->
<template>
    <transition
        enter-active-class="animated fast fadeInDown"
        leave-active-class="animated fast fadeOutUp"
    >
        <div class="lanhu-popup" v-show="popupVisible">
            <div class="popup-content" :class="status" v-show="status && content">
                <div>
                    <img :src="backgroundIcon" class="popup-icon" />
                    <span v-html="content"></span>
                </div>
            </div>
        </div>
    </transition>
</template>
<style lang="scss" scoped>
.lanhu-popup {
    position: absolute;
    z-index: 2018;
    top: 0;
    left: 0;
    width: 100%;
    min-height: 2.5rem;
    .popup-content {
        display: flex;    
        align-items: center;
        min-height: 2.5rem;
        justify-content: center;
        font-size: 0.75rem;
        font-weight: 400;
        text-align: center;
        color: white;
        padding-top: constant(safe-area-inset-top);
        padding-top: env(safe-area-inset-top);
        .popup-icon {
            position: relative;
            top: 0.1rem;
            margin-right: 0.15rem;
            width: 0.75rem;
            height: 0.75rem;
        }
    }
    .popup-content.succeed {
        background: #57d092;
    }
    .popup-content.failed {
        background: #ff3366;
    }
    .popup-content.normal {
        background: #69a7ec;
    }
}
</style>
<script>
export default {
    name: "Popup",
    data() {
        return {
            status: "",
            content: "",
            popupVisible: false
        }
    },
    computed: {
        backgroundIcon() {
            if (this.status == "succeed") {
                return require("../../assets/imgs/succeed.png")
            }
            if (this.status == "failed") {
                return require("../../assets/imgs/failed.png")
            }
            if (this.status == "normal") {
                return require("../../assets/imgs/normal.png")
            }
        }
    },
    mounted() {
        this.$root.eventBus.$on("showTip", this.showTip)
    },
    methods: {
        popup(content, status) {
            if (window.isWebview) {
                StatusBar.hide()
            }

            this.content = content
            this.popupVisible = true
            this.status = status
            setTimeout(() => {
                this.popupVisible = false
                if (this.$route.name !== "proto" && window.isWebview) {
                    StatusBar.show()
                }
            }, 1500)
        },
        showTip(content, status) {
            this.popup(content, status)
        }
    }
}
</script>


